// MenuComponent.js
import { SmartComponent } from "smart-component-js";

class MenuComponent extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    this.element = element;
    this.init();
  }

  init() {
    this.setupMenu();
    this.setupEventListeners();
  }

  setupMenu() {
    this.hideMenu();
  }

  setupEventListeners() {
    document.addEventListener("show-menu", () => {
      this.showMenu();
    });

    document.addEventListener("hide-menu", () => {
      this.hideMenu(false);
    });

    const closeButton = this.element.querySelector(".menu__close-button");
    if (closeButton) {
      closeButton.addEventListener("click", () => this.hideMenu());
      closeButton.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.hideMenu();
        }
      });
    }

    const leftCloseButton = this.element.querySelector(".menu__left-close");
    if (leftCloseButton) {
      leftCloseButton.addEventListener("click", () => this.hideMenu());
      leftCloseButton.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.hideMenu();
        }
      });
    }
  }

  showMenu() {
    this.element.classList.add("is-active");
    this.element.setAttribute("aria-hidden", "false");
    this.element.setAttribute("tabindex", "-1");
  }

  hideMenu(emitEvent = true) {
    this.element.classList.remove("is-active");
    this.element.setAttribute("aria-hidden", "true");
    this.element.removeAttribute("tabindex");

    if (emitEvent) {
      const hideOverlayEvent = new CustomEvent("hide-overlay");
      document.dispatchEvent(hideOverlayEvent);
    }
  }
}

export default MenuComponent;
